import { Activity, Anchor, ArrowDownToLine, ArrowUpRight, Crosshair, Dribbble, Expand, Eye, Flame, Footprints, Hand, Layers, Megaphone, MoveRight, Play, Repeat, Rocket, Route, Share2, Shuffle, Swords, Target, TrendingUp, Users, Wind, Zap } from "lucide-react";

// One icon per pick (by library ID). Unknown / retired IDs fall back per list.
export const PICK_ICONS = {
  // Role responsibilities
  "RESP-01": Route, "RESP-03": Flame, "RESP-04": Share2, "RESP-05": MoveRight, "RESP-07": Crosshair, "RESP-43": Footprints, "RESP-44": Layers, "RESP-15": Anchor,
  "RESP-37": Play, "RESP-10": Wind, "RESP-38": Rocket, "RESP-39": Repeat, "RESP-21": Anchor, "RESP-22": Shuffle, "RESP-45": ArrowDownToLine, "RESP-31": Zap, "RESP-32": Megaphone,
  // Defensive matchups
  "MAT-01": Hand, "MAT-02": Users, "MAT-03": Swords, "MAT-04": MoveRight, "MAT-05": Rocket, "MAT-06": Footprints, "MAT-07": Activity, "MAT-08": Target,
  "MAT-09": Expand, "MAT-10": Anchor, "MAT-11": Crosshair, "MAT-12": ArrowUpRight, "MAT-13": Eye,
  // Play types
  "PT-01": Dribbble, "PT-02": Layers, "PT-03": Target, "PT-04": Footprints, "PT-05": Swords, "PT-06": Anchor, "PT-07": Zap, "PT-08": Wind, "PT-09": TrendingUp,
};
export const pickIcon = (id, fallback) => PICK_ICONS[id] || fallback;
